import { SingleRadio } from "components/Atoms/inputs/RadioGroup";
import OptionalNumberInput from "components/ValidatedFields/OptionalNumberInput";
import React from "react";

interface PriceInputProps {
  isValueIncVat: boolean
  valueExVat: number
  valueIncVat: number
  onChange: (isValueIncVat: boolean, value: number) => void;
}

export const PriceInput = (props: PriceInputProps) => {
  return <div className="flex-column gap">
    <div className="flex gap-larger align-center">
      <SingleRadio<boolean>
        value={false}
        selected={props.isValueIncVat}
        onChange={() => props.onChange(false, props.valueExVat)}
      />
      <OptionalNumberInput
        autoFocus
        width={90}
        value={props.valueExVat}
        onChange={(v: number) => {
          if (v !== props.valueExVat) {
            props.onChange(false, v)
          }
        }}
        decimalPoints={2}
      />
      {RESX.Financial.ExcludingTax}
    </div>
    <div className="flex gap-larger align-center">
      <SingleRadio<boolean>
        value={true}
        selected={props.isValueIncVat}
        onChange={() => props.onChange(true, props.valueIncVat)}
      />
      <OptionalNumberInput
        autoFocus
        width={90}
        value={props.valueIncVat}
        onChange={(v: number) => {
          if (v !== props.valueIncVat) {
            props.onChange(true, v)
          }
        }}
        decimalPoints={2}
      />
      {RESX.Financial.IncludingTax}
    </div>
  </div>
}